import { render } from "./IdentityModal.vue?vue&type=template&id=01ecc03c&scoped=true"
import script from "./IdentityModal.vue?vue&type=script&lang=js"
export * from "./IdentityModal.vue?vue&type=script&lang=js"

import "./IdentityModal.vue?vue&type=style&index=0&id=01ecc03c&lang=css"
import "./IdentityModal.vue?vue&type=style&index=1&id=01ecc03c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01ecc03c"

export default script